import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const ClientLoveUs = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="relative bottom-16 lg:mt-0 lg:py-10 ">
        <div className="container mx-auto pt-10 mt-10">
          <p className="text-center font-semibold text-[#7B68EC] lg:text-sm text-[10px] pb-5">
            Clients Love Us
          </p>
          <p className="lg:text-5xl text-nowrap text-[16px] text-black font-semibold text-center">
            Why Clients Love Us!
          </p>
          <div className="lg:my-4 my-2 w-full">
            <p className="text-center text-black lg:text-sm text-[10px]">
              Male the right hires, Faster with the world leading company
            </p>
          </div>

          <div className="flex lg:flex-row sm:flex-row flex-col gap-10 pt-10 mt-10">
            <div className="lg:w-1/3">
              {theme == "glassy" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./members.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "light" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./members.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "dark" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./members-dark.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./members.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              )}
              <div className="mx-3 lg:mx-0">
                <p className="text-black font-semibold text-lg py-3">
                  Trusted by Clients, Driven by Excellence
                </p>
                <p className="text-black text-sm opacity-60">
                  At Visual Folio, our commitment to quality, innovation, and
                  seamless execution makes us a trusted partner for businesses
                  worldwide. We go beyond expectations, delivering exceptional
                  results with precision, creativity, and reliability. Your
                  success is our mission!
                </p>
              </div>
            </div>
            <div className="lg:w-1/3">
              {theme == "glassy" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./members.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "light" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./progress-light.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "dark" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./progress-dark.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./progress.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              )}
              <div className="mx-3 lg:mx-0">
                <p className="text-black font-semibold text-lg py-3">
                  Delivering Quality, Innovation & Success
                </p>
                <p className="text-black text-sm opacity-60">
                  At Visual Folio, we blend creativity with cutting-edge
                  solutions to deliver exceptional results. Our focus on
                  quality, innovation, and strategic execution ensures that
                  every project drives success and exceeds expectations. Let’s
                  build something extraordinary together!
                </p>
              </div>
            </div>
            <div className="lg:w-1/3">
              {theme == "glassy" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./cards.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "light" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./cards-light.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : theme === "dark" ? (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./cards-dark.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              ) : (
                <div>
                  <StaticImage
                    className="mx-3 lg:mx-0"
                    src="./cards.png"
                    alt="resourceHero"
                    placeholder="blurred"
                    layout="fullWidth"
                  />
                </div>
              )}
              <div className="mx-3 lg:mx-0">
                <p className="text-black font-semibold text-lg py-3">
                  Your Vision, Our Commitment to Perfection
                </p>
                <p className="text-black text-sm opacity-60">
                  At Visual Folio, we turn your ideas into reality with
                  precision and passion. Our dedicated team ensures every detail
                  is crafted to perfection, delivering innovative and
                  high-quality solutions that bring your vision to life. Let’s
                  create something remarkable together!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
